define('uikit/collections/components.container.view',['require','exports','module','marionette','underscore','../mixins/component.mixin','../extra/static.methods','../extra/extend.util'],function(require, exports, module) {
  var Mn             = require('marionette');
  var _              = require('underscore');
  var ComponentMixin = require('../mixins/component.mixin');
  var StaticMethods  = require('../extra/static.methods');
  var ExtendUtil     = require('../extra/extend.util');

  var ComponentsContainerView = Mn.CollectionView.extend(ComponentMixin, StaticMethods).extend({

    options: {
      components: null
    },

    initialize: function() {
      ComponentMixin.initialize.apply(this, arguments);

      if (!this.collection) {
        this.collection = new Backbone.Collection();
      }
      if (this.hasComponents()) {
        this.collection.set(this.getComponents());
      }
    },

    getChildView: function(model) {
      return this.getComponentByType(model.get('type')) || this.getOption('childView');
    },

    buildChildView: function(child, ChildViewClass, childViewOptions) {
      var options = _.extend({
        injectInternalViewsSynchronously: this.getOption('injectInternalViewsSynchronously')
      }, childViewOptions, _.omit(child.attributes, 'type'));

      ChildViewClass = ExtendUtil.extendClassBehaviors(ChildViewClass, childViewOptions);
      ChildViewClass = ExtendUtil.extendClassBehaviors(ChildViewClass, { behaviors: child.get('behaviors') });

      if (this.hasComponents() && this.model && !options.model) {
        // if we are using components (rather than a true data collection)
        // we want to use the parent model rather than the model that represents
        // the component definition
        _.extend(options, { model: this.model });
      }

      // name options have the higher priority so these must go last
      var namedOptions = Mn._getValue(this.getOption(options.name), this);
      options = (options.name) ? _.extend(options, namedOptions) : options;
      ChildViewClass = ExtendUtil.extendClassBehaviors(ChildViewClass, namedOptions);

      return Mn.CollectionView.prototype.buildChildView.call(this, child, ChildViewClass, options);
    },

    getComponents: function() {
      return Mn._getValue(this.getOption('components') || [], this);
    },

    hasComponents: function() {
      return this.getOption('components') != null;
    },

    onChangeComponents: function() {
      this.collection.set(this.getComponents());
    }

  });

  module.exports = ComponentsContainerView;
});

